/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DTO para un evento del \"Play-by-Play\".
 */
export interface MatchEventDetailsDTO { 
    minute: number;
    second: number;
    event_type: string;
    home_score?: number | null;
    away_score?: number | null;
    player_id?: string | null;
    player_name?: string | null;
    team_id?: string | null;
    team_name?: string | null;
}

